var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('a-spin', {
    attrs: {
      "spinning": _vm.loading
    }
  }, [_c('a-tabs', {
    style: {
      height: '800px'
    },
    attrs: {
      "default-active-key": "1",
      "tab-position": _vm.mode
    },
    on: {
      "change": _vm.tabChanged
    }
  }, _vm._l(_vm.allProvisionings, function (provisioning) {
    return _c('a-tab-pane', {
      key: provisioning.id,
      attrs: {
        "tab": provisioning.name
      }
    }, [_c('h5', [_vm._v("Edit message")]), _c('div', {
      staticStyle: {
        "width": "50%"
      }
    }, [_c('a-input', {
      staticClass: "item",
      attrs: {
        "placeholder": "Email subject"
      },
      model: {
        value: _vm.title,
        callback: function callback($$v) {
          _vm.title = $$v;
        },
        expression: "title"
      }
    }), _c('a-input', {
      staticClass: "item",
      attrs: {
        "placeholder": "Email BCC"
      },
      model: {
        value: _vm.bcc,
        callback: function callback($$v) {
          _vm.bcc = $$v;
        },
        expression: "bcc"
      }
    }), _c('a-textarea', {
      staticClass: "item",
      staticStyle: {
        "min-height": "200px"
      },
      attrs: {
        "placeholder": "Email body",
        "auto-size": ""
      },
      model: {
        value: _vm.body,
        callback: function callback($$v) {
          _vm.body = $$v;
        },
        expression: "body"
      }
    }), _c('a-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.allProvisionings.length > 0,
        expression: "allProvisionings.length > 0"
      }],
      staticClass: "btn btn-success px-5 float-right",
      on: {
        "click": _vm.onSubmit
      }
    }, [_vm._v(" Save ")])], 1)]);
  }), 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }